import React from "react";
import Navbar from "../Components/Navbar";
import TeamHeader from "../Components/TeamHeader";
import Footer from "../Components/Footer";
import TeamSection from "../Components/TeamSection";

const Team = () => {
  return (
    <div>
      <Navbar />
      <TeamHeader />
      <TeamSection />
      <Footer />
    </div>
  );
};

export default Team;
